import { Card, HeaderMenu, Loading } from "components";
import { prevYear, thisMonth, thisWeek, thisYear, today } from "utils";
import { useFilter, useList } from "./hooks";
import { FilterByDate } from "pages/Finance/Register/components";
import moment from "moment";

export default function AnalyseSalesComparation() {

    const todayDate = today()
    const prevYearDate = prevYear()
    const thisYearDate = thisYear()
    const thisMonthDate = thisMonth()
    const thisWeekDate = thisWeek()

    const { filter, handleChangeFilter } = useFilter({
        dateFrom: thisMonthDate.fromDate,
        dateTo: todayDate
    })


    const { data, isLoading } = useList({
        start_date: filter.dateFrom,
        end_date: filter.dateTo
    });
    


    const getTotal = (item: any, locations: string[]) =>
        locations.reduce(
            (sum, loc) => sum + (Number(item[loc]) || 0),
            0
        )


    return (
        <section>
            <section className="mt-1 mx-3">
                <HeaderMenu title="ANALYSE SALES COMPARATION " />
            </section>

            <section className="mx-3">
                <Card>
                    <Card.Body>
                        <FilterByDate
                            permission=""
                            dateFrom={filter.dateFrom}
                            dateTo={filter.dateTo}
                            onChangeDateFrom={(dateFrom) => {
                                const isValid = moment(dateFrom).isBefore(filter.dateTo)
                                handleChangeFilter({
                                    dateFrom,
                                    dateTo: isValid ? filter.dateTo : dateFrom
                                })
                            }}
                            onChangeDateTo={(dateTo) => handleChangeFilter({ dateTo })}
                            onClickPrevYear={() =>
                                handleChangeFilter({
                                    dateFrom: prevYearDate.fromDate,
                                    dateTo: prevYearDate.toDate
                                })
                            }
                            onClickThisYear={() =>
                                handleChangeFilter({
                                    dateFrom: thisYearDate.fromDate,
                                    dateTo: thisYearDate.toDate
                                })
                            }
                            onClickThisWeek={() =>
                                handleChangeFilter({
                                    dateFrom: thisWeekDate.fromDate,
                                    dateTo: thisWeekDate.toDate
                                })
                            }
                            onClickThisMonth={() =>
                                handleChangeFilter({
                                    dateFrom: thisMonthDate.fromDate,
                                    dateTo: thisMonthDate.toDate
                                })
                            }
                            onClickToday={() =>
                                handleChangeFilter({
                                    dateFrom: todayDate,
                                    dateTo: todayDate
                                })
                            }
                        />
                    </Card.Body>
                </Card>
            </section>

            <section className="mx-3">
                <Card>
                    <Card.Body>
                        <div className="overflow-x-auto max-h-[calc(100vh-400px)]">
                            <table className="table table-bordered">
                                <thead className="top-0 z-1 !bg-black !text-white">
                                    <tr>
                                        <th rowSpan={2}>NO</th>
                                        <th rowSpan={2}>CODE</th>
                                        <th rowSpan={2}>DESCRIPTION</th>
                                        <th rowSpan={2}>UNIT (SALES) </th>
                                        <th rowSpan={2}>TOTAL SOLD QUANTITY</th>
                                        <th colSpan={data?.locations?.length}>LOCATION</th>
                                    </tr>
                                    <tr>
                                        {data.locations?.map(loc => (
                                            <th key={loc}>{loc}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <tr>
                                            <td colSpan={5 + data.locations?.length} className="text-center">
                                                <Loading loading={isLoading} />
                                            </td>
                                        </tr>
                                    ) : data.payload?.length === 0 ? (
                                        <tr>
                                            <td colSpan={5 + data.locations?.length} className="text-center">
                                                No data available
                                            </td>
                                        </tr>
                                    ) : (
                                        data.payload?.map((item, index) => (
                                            <tr key={item.code}>
                                                <td className="text-center">{index + 1}</td>
                                                <td>{item.code}</td>
                                                <td>{item.description}</td>
                                                <td>{item.unit}</td>

                                                {/* TOTAL SOLD */}
                                                <td className="text-center font-semibold">
                                                    {getTotal(item, data.locations)}
                                                </td>

                                                {/* LOCATION QTY */}
                                                {data.locations.map(loc => (
                                                    <td key={loc} className="text-center">
                                                        {item[loc] ?? 0}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))
                                    )}
                                </tbody>

                            </table>
                        </div>

                    </Card.Body>
                </Card>
            </section>

        </section>
    )
}